var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1782_2142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 1.3335C2.70065 1.3335 0.833984 3.20016 0.833984 5.50016C0.833984 7.80016 2.70065 9.66683 5.00065 9.66683C7.30065 9.66683 9.16732 7.80016 9.16732 5.50016C9.16732 3.20016 7.30065 1.3335 5.00065 1.3335ZM3.87148 7.28766L2.37565 5.79183C2.21315 5.62933 2.21315 5.36683 2.37565 5.20433C2.53815 5.04183 2.80065 5.04183 2.96315 5.20433L4.16732 6.40433L7.03398 3.53766C7.19648 3.37516 7.45898 3.37516 7.62148 3.53766C7.78398 3.70016 7.78398 3.96266 7.62148 4.12516L4.45898 7.28766C4.30065 7.45016 4.03398 7.45016 3.87148 7.28766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1782_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumCheck);
export default __webpack_public_path__ + "static/media/Premium-Check.9316f83e96fa029690da1915084fd75c.svg";
export { ForwardRef as ReactComponent };